<template>
  <div class="cascader" v-if="articleLabels && articleLabels.length">
    <el-cascader
      v-if="app_type == 'man' || item.invisibleStatus !== 4"
      class="select-role"
      :options="articleLabels"
      :value="labelValue"
      ref="countrySelectRef"
      :props="{
        multiple: false,
        value: 'id',
        label: 'name',
        children: 'contentLabels',
        checkStrictly: true,
        disabled: 'disableSelected',
      }"
      @change="handleChange"
    >
      <template slot-scope="{ node, data }">
        <el-tooltip
          :disabled="data.name.length < 18"
          class="item"
          effect="dark"
          :content="data.name"
          placement="top"
        >
          <span>{{ data.name }}</span>
        </el-tooltip>
      </template>
    </el-cascader>
  </div>
</template>

<script>
import { request } from "@/utils/axios";

var app_type = process.env.VUE_APP_TYPE;

export default {
  name: "contentLabelCascader",
  props: ["articleId", "functionIds", "selectedId", "labelType", "pid"],
  data() {
    return {
      articleLabels: [],
      labelValue: [],
      app_type,
    };
  },
  async created() {
    if (app_type == "man") {
      try {
        this.listContentLabelsForAudit();
      } catch (e) {
        console.log(e);
      }
    }
  },
  methods: {
    handleChange(value) {
      this.labelValue = value;
    },
    async handleClick() {
      var res = await request(this.functionIds.operateApi, {
        tenantId: this.$commonJs.getTenantId(),
        fromLabelId: +this.selectedId,
        toLabelId: this.labelValue[this.labelValue.length - 1],
      });
      if (res) {
        this.$message.success("操作成功!");
      } else {
        console.log(res);
        this.$message.error(res);
      }
    },
    // 运营端 -------- 获取审核文章时的标签组和标签信息
    async listContentLabelsForAudit() {
      var res = await request(this.functionIds.getArticleLabel, {
        tenantId: this.$commonJs.getTenantId(),
        labelType: this.labelType,
      });
      if (res.code != "1900") {
        // fix: 验证res.find
        this.articleLabels = res?.data.find(
          (item) => item.id === +this.pid
        )?.contentLabels;
        // 标记来源id为不可选状态
        const recursionObj = (node, callback, judge) => {
          if (judge(node)) {
            node = callback(node);
          }
          if (!node.contentLabels || node.contentLabels.length === 0) {
            return;
          }
          for (let i = 0; i < node.contentLabels.length; i++) {
            if (judge(node)) {
              recursionObj(node.contentLabels[i], callback, () => true);
            } else {
              recursionObj(node.contentLabels[i], callback, judge);
            }
          }
          return;
        };
        for (let i = 0; i < this.articleLabels?.length; i++) {
          recursionObj(
            this.articleLabels[i],
            (curNode) => {
              curNode.disableSelected = true;
              return curNode;
            },
            (node) => node.id === this.selectedId
          );
        }

        this.articleLabels?.forEach((oneLevel) => {
          oneLevel.contentLabels.forEach((twoLevel, index) => {
            if (twoLevel.contentLabels.length > 0) {
              twoLevel.disabled = true;
              twoLevel.contentLabels.forEach((item) => {
                item.contentLabels.forEach((three) => {
                  if (three.contentLabels.length < 1) {
                    three.contentLabels = undefined;
                  }
                });
                if (item.contentLabels.length > 0) {
                  // item.disabled = true;
                } else {
                  item.contentLabels = undefined;
                }
              });
            } else {
              twoLevel.disabled = false;
              twoLevel.contentLabels = undefined;
            }
          });
        });
        this.articleLabels?.map((item) => {
          item.valueId = [];
          // 第一级
          item.contentLabels.map((dataOne) => {
            if (dataOne.isChecked) {
              item.valueId.push([dataOne.id]);
            }
            // 第二级
            if (dataOne.contentLabels) {
              dataOne.contentLabels.map((dataTwo) => {
                if (dataTwo.isChecked) {
                  item.valueId.push([dataOne.id, dataTwo.id]);
                }
                // 第三级
                if (dataTwo.contentLabels) {
                  dataTwo.contentLabels.map((three) => {
                    if (three.isChecked) {
                      item.valueId.push([dataOne.id, dataTwo.id, three.id]);
                    }
                  });
                }
              });
            }
          });
          // this.labelValue.push(item.valueId)
        });
      } else {
        this.articleLabels = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cascader {
  padding: 0;
  padding-top: 30px;
  display: flex;
  align-content: center;
}
.el-cascader {
  margin: 0 auto;
}
// 点击文字选中
.el-cascader-panel .el-checkbox {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
}

.el-cascader-node__label {
  margin-left: 10px;
}

:deep(.el-input) {
  width: 600px !important;
}

// 文字过多，省略样式
.content-item p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
